//collection page sidebar accordion
var acc = document.getElementsByClassName("accordion");
var i;
for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}

//read more btn description PDP page/
$(".readmore1").click(function() {
    $('html, body').animate({
        scrollTop: $("#scroll_tab").offset().top
    }, 2000);
});

document.addEventListener("DOMContentLoaded", function () {
  if (window.location.pathname.startsWith("/blogs")) {
    document.body.classList.add("blogs");
  }
});